export class configSettings {
    static environment = 'https://timeapp.rosendin.com/rosendintimeapi';
    static loginAPI = 'https://timeapp.rosendin.com/rosendintimeapi'; //Variable for api through webserver URL
    static isAllowSSOLogin = true;// For local it will be false;
    static routeEnvironmentURL = 'http://localhost:50700';
    static httpRedirect = false;
    static googleAnalyticsKey = '';
    static isDev = true;
    static botEnvironment = 'http://localhost:3001';
    static copyrightContent = "@Copyright 2026 - Rosendin";
}